document.addEventListener("DOMContentLoaded", function () {

    $('.select-status').select2({
        width: '100%',
        placeholder: 'Seleccione los documentos'
    });

    $('.documents-select').select2({
        ajax: {
            url: '/audit_process_status/documents_data',
            type: 'GET',
            dataType: 'json',
            delay: 250,
            data: function (params) {
                return { q: params.term };
            },
            processResults: function (data) {
                return { results: data };
            }
        },
        multiple: true,
        placeholder: 'Selecciona un documento.',
        width: '100%',
    });

});
